import {CheatsModule} from '@gongxigames/framework/slot';
import session from './plugins/session';
import info from './plugins/Info';
import matrix from './plugins/matrix';
import filters from './plugins/filters';
import demo from './plugins/demo';
import reelsSetMatrix from './plugins/reelsSetMatrix';
import errors from './plugins/errors';
import soundTool from './plugins/soundTool';
import settings from './plugins/settings';

CheatsModule.registerPlugin(info);
CheatsModule.registerPlugin(filters);
CheatsModule.registerPlugin(demo);
CheatsModule.registerPlugin(matrix);
CheatsModule.registerPlugin(reelsSetMatrix);
CheatsModule.registerPlugin(session);
CheatsModule.registerPlugin(errors);
CheatsModule.registerPlugin(soundTool);
CheatsModule.registerPlugin(settings);